import api from '@/utils/api';

/**
 * Update a Dealers quotes
 * @param {string} quoteId Quote id
 * @param {object} quoteData - The quote data
 * @returns {Promise}
 */
const updateDealerQuoteApi = (quoteId, quoteData) =>
  api.patch(`/quote/${quoteId}`, quoteData);

export default updateDealerQuoteApi;
